module.exports = __webpack_public_path__ + "static/media/gallery-img-13.55a6342b.jpg";